module.exports = "<button mat-stroked-button class=\"pnd-ZoomOut\">\n  <mat-icon>remove</mat-icon>\n</button>\n"